module.exports = __webpack_public_path__ + "media/shared/images/tolo_dot-f8585d1fcf2f119e06b8edae0448b779.svg";